import _cloneDeep from 'lodash/cloneDeep';

export function cloneSingleSignOnConfiguration(singleSignOnConfiguration) {
  return _cloneDeep(singleSignOnConfiguration);
}
